<template>
  <div class="app-mnpout-data-wrapper" ref="wrapper">
    <div v-if="!loading && !showError">
      <LoginConfirm ref="doLoginConfirmRef"></LoginConfirm>
      <SimonModal :is-visible="showPortingModal"
                  id="porting-info-modal"
                  @hide="showPortingModal = false"
      >
        <slot name="txtPortingModal"></slot>
      </SimonModal>
      <SimonModal :is-visible="showOptInModal"
                  size="large"
                  id="optin-info-modal"
                  @hide="showOptInModal = false"
      >
        <slot name="txtOptInModal"></slot>
      </SimonModal>
      <h4><slot name="txtHeadline">Benötigte Informationen</slot></h4>
      <b-row class="mnpout-data-table">
        <b-col class="lblTxt"><slot name="txtCurrentDate">Aktuelles Datum</slot></b-col>
        <b-col class="dataTxt">{{ dateTimeFormatter(mnpOutStatus.requestDate) }}</b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col class="lblTxt"><slot name="txtCustomerType">Kundentyp</slot></b-col>
        <b-col class="dataTxt">{{ mnpOutStatus.customerType }}</b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col class="lblTxt"><slot name="txtCustomerSurname">Vorname</slot></b-col>
        <b-col class="dataTxt">{{ currentCustomer.firstName }}</b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col class="lblTxt"><slot name="txtCustomerName">Nachname</slot></b-col>
        <b-col class="dataTxt">{{ currentCustomer.lastName }}</b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col class="lblTxt" ><slot name="txtCustomerBirthday">Geburtsdatum</slot></b-col>
        <b-col class="dataTxt" v-if="currentCustomer.birthDate !== null">{{ currentCustomer.birthDate }}</b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col class="lblTxt"><slot name="txtMnp">Zu portierende Rufnummer</slot></b-col>
        <b-col class="dataTxt">+{{ currentCustomer.contract.msisdn }}</b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col class="lblTxt"><slot name="txtSimonPortingNumber">SIMon mobile-Portierungskennung</slot><a class="info-link-icon" @click="showPortingModal=true"></a></b-col>
        <b-col class="dataTxt">{{ mnpOutStatus.serviceProviderCode }}</b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col class="lblTxt"><slot name="txtCancellationDate">Kündigungsdatum</slot></b-col>
        <b-col class="dataTxt">{{ dateTimeFormatter(mnpOutStatus.terminationDate) }}</b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col class="lblTxt"><slot name="txtOptInDate">Opt-In-Gültigkeitsdatum</slot><a class="info-link-icon" @click="showOptInModal=true"></a></b-col>
        <b-col class="dataTxt">{{ dateTimeFormatter(mnpOutStatus.optInValidity) }}</b-col>
      </b-row>
      <hr>
      <center>
        <button class="button-border" @click="downloadPdf">
          <slot name="txtDownloadButton">Portierungsdaten herunterladen</slot>
        </button>
      </center>
    </div>
    <div v-if="showError" v-html="this.errorMsg" class="error-box"></div>
  </div>
</template>

<script>
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import { splitError } from '@/helper/splitError'
import FileSaver from 'file-saver'
import appFileSaver from '@/mixins/appFileSaver'
import LoginConfirm from '@/components/process/generic/Login/LoginConfirm.vue'
import doLoginConfirm from '@/mixins/doLoginConfirm'
import dateFormatter from '@/mixins/formatters/dateFormatter'
import SimonModal from '@/components/modal/SimonModal.vue'

export default {
  name: 'MnpOutDataWrapper',
  data () {
    return {
      currentCustomer: null,
      tariffs: null,
      mnpOutStatusPdf: null,
      mnpOutStatus: null,
      showPortingModal: false,
      showOptInModal: false,
      loading: true,
      loadingPdf: false,
      showError: false,
      errorMsg: {
      }
    }
  },
  mounted () {
    this.startLoader()
    this.resetLoginConfirm()
  },
  components: {
    SimonModal,
    LoginConfirm
  },
  mixins: [
    doLoginConfirm('doLoginConfirmRef'),

    appFileSaver,
    dateFormatter
  ],
  methods: {
    dateTimeFormatter (date) {
      if (date !== null) {
        return this.dateFormatter(new Date(date))
      }

      return ''
    },
    downloadPdf: function () {
      this.doLoginConfirm().then(() => {
        this.loadingPdf = true
        const me = this
        const graphQlClient = me.$apolloProvider.defaultClient
        graphQlClient.query({
          query: gql`query mnpOutStatus {
            mnpOutStatusPdf {
              contentType
              document
            }
          }`
        }).then(response => {
          this.loadingPdf = false
          if (response.data.mnpOutStatusPdf !== null) {
            this.showError = false
            const decodedDocumentPdf = Uint8Array.from(atob(response.data.mnpOutStatusPdf.document), c => c.charCodeAt(0))
            const file = new Blob([decodedDocumentPdf], { type: response.data.mnpOutStatusPdf.contentType })
            if (this.appTriggerSaveAsFileAvailable()) {
              this.appTriggerSaveAsFile('mnp-status.pdf', file)
            } else {
              FileSaver.saveAs(file, 'mnp-status.pdf')
            }
          } else {
            this.showError = true
            const errMsg = 'Die PDF konnte nicht heruntergeladen werden.'
            me.$store.commit('addError', errMsg)
            this.errorMsg = errMsg
            const data = {
              type: 'technical',
              message: errMsg
            }
            if (typeof window.trackingNS?.track?.tracking === 'function') {
              window.trackingNS.track.tracking('error', data)
            }
          }
        }).catch((error) => {
          this.loadingPdf = false
          this.showError = true
          let errMsg = ''
          splitError(error).forEach(e => {
            me.$store.commit('addError', e)
            errMsg += e.message
          })
          this.errorMsg = errMsg
          const data = {
            type: 'technical',
            message: errMsg
          }
          if (typeof window.trackingNS?.track?.tracking === 'function') {
            window.trackingNS.track.tracking('error', data)
          }
        })
        return false
      })
    }
  },
  apollo: {
    tariffs: function () {
      this.loading = true
      return wrapQuery(
        gql`query TariffDetails {
          currentCustomer {
            customerId
            firstName
            lastName
            birthDate
            contract {
              msisdn
              state
              nextPossibleDismissalDate
            }
          }
          tariffs {
            bookedTariff {
              contractStartDate
            }
          }
          mnpOutStatus {
            customerType
            optInValidity
            serviceProviderCode
            requestDate
            terminationDate
          }
        }`, this, ['tariffs', 'currentCustomer', 'mnpOutStatus'], {}, () => {
          this.loading = false
          this.showError = false
          this.stopLoader()
        },
        {
          fetchPolicy: 'cache-first'
        },
        (error) => {
          this.loading = false
          splitError(error).forEach(e => {
            this.errorMsg = e.message
          })
          if (!this.showError) {
            const data = {
              type: 'technical',
              message: this.errorMsg
            }
            if (typeof window.trackingNS?.track?.tracking === 'function') {
              window.trackingNS.track.tracking('error', data)
            }
          }
          this.showError = true
          this.stopLoader()
        }
      )
    }
  }
}
</script>
